import { SelectC } from 'components'
import { useLoadOrderPaymentMethods } from 'modules/orders/hooks'
import { useEffect, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useLocation } from 'react-router-dom'
import { useDebounce } from 'utils'

type Props = {
  name: string
  disabled?: boolean
  isAdvance?: boolean
}

const filterPaymentMethods = (data: any, isAdvance?: boolean) => {
  return data?.filter((item: any) => {
    return !!item.isAdvance === !!isAdvance
  })
}

export function SelectPaymentMethods(props: Props) {
  const { name, disabled, isAdvance } = props
  const [search, setSearch] = useState('')
  const [options, setOptions] = useState<any[]>([])
  const searchDebounced = useDebounce(search, 250)
  const { watch, setValue } = useFormContext()

  const [unityId, paymentTerm] = watch(['unity', 'paymentTerm'])

  const pageLocation = useLocation()

  const isEdit = pageLocation.pathname.includes('edit')
  const isDuplicatePage = pageLocation.pathname.includes('/duplicate')
  const currentPaymentMethod = watch(name)

  const handleChangeCustomer = (value: string, reason: string) => {
    if (reason === 'input' || reason === 'clear') setSearch(value)
  }

  const paymentMethods = useLoadOrderPaymentMethods({
    page: 1,
    limit: 100,
    search: searchDebounced,
    unityId: unityId?.id,
    paymentTermId: paymentTerm?.id
  })

  const filteredMethods = useMemo(
    () => filterPaymentMethods(paymentMethods?.data?.data, isAdvance),
    [paymentMethods?.data?.data, isAdvance]
  )

  useEffect(() => {
    setOptions(paymentMethods?.data?.data || [])

    let paymentMethod = null
    if (
      paymentMethods?.data?.data?.length &&
      paymentMethods?.data?.data?.length > 1
    ) {
      if (filteredMethods?.length === 1) {
        paymentMethod = filteredMethods[0]
        setOptions(filteredMethods)
      } else {
        paymentMethod = null
      }
    } else if (paymentMethods?.data?.data?.length === 1) {
      paymentMethod = paymentMethods?.data?.data[0]
    } else {
      paymentMethod = null
    }

    const shouldAutoSet =
      !isEdit && !isDuplicatePage && !currentPaymentMethod?.id

    if (shouldAutoSet) setValue(name, paymentMethod)
  }, [
    currentPaymentMethod?.id,
    filteredMethods,
    isDuplicatePage,
    isEdit,
    name,
    paymentMethods?.data?.data,
    setValue
  ])

  return (
    <SelectC
      name={name}
      options={options}
      onInputChange={(e, value, reason) => handleChangeCustomer(value, reason)}
      label="Tipo de Pagamento"
      loading={paymentMethods.isLoading}
      disabled={disabled}
      getOptionLabel={(option: any) => option?.name}
    />
  )
}
